import * as React from 'react';
import { st, classes } from './ActionsMenuLayout.st.css';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { ActionsMenuLayoutItem } from './Item/ActionsMenuLayoutItem';
import { ActionsMenuLayoutDivider } from './ActionsMenuLayoutDivider/ActionsMenuLayoutDivider';
import { KEYS } from '../../common/keyCodes';
import { ActionsMenuLayoutDataHooks, } from './types';
/** ActionsMenuLayout */
export class ActionsMenuLayout extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            focusedIdx: this.props.focusedIndex ?? 0,
        };
        this.liRefs = {};
        this._onKeyDown = (e) => {
            if (e.key === KEYS.ArrowDown || e.key === KEYS.ArrowDownIE) {
                e.preventDefault(); // remove scroll on space
                this._focusItem(this._getNextItemIdx(1));
            }
            if (e.key === KEYS.ArrowUp || e.key === KEYS.ArrowUpIE) {
                e.preventDefault(); // remove scroll on space
                this._focusItem(this._getNextItemIdx(-1));
            }
        };
        this._onFocus = (e) => {
            const focusOnChild = !!Object.values(this.liRefs).find((i) => i.liRef?.current === e.target);
            // focus on initial list item after tab focusing
            if (!focusOnChild) {
                this._focusItem(0);
            }
        };
        // prevent firing focus after mouse click events
        this._preventFocus = (e) => e.preventDefault();
    }
    componentDidMount() {
        const { focusedIndex } = this.props;
        if (typeof focusedIndex !== 'undefined') {
            this._focusItem(focusedIndex);
        }
    }
    getDataAttributes(mobile) {
        return {
            [ActionsMenuLayoutDataHooks.mobile]: mobile,
        };
    }
    _getNextItemIdx(direction) {
        const nextItem = this.state.focusedIdx + direction;
        if (direction === 1) {
            return nextItem === Object.values(this.liRefs).length ? 0 : nextItem;
        }
        return nextItem < 0 ? Object.values(this.liRefs).length - 1 : nextItem;
    }
    _addRef(ref, index) {
        if (ref) {
            this.liRefs[index] = ref;
        }
    }
    _focusItem(idx) {
        this.setState({
            focusedIdx: idx,
        }, () => {
            Object.values(this.liRefs)[idx]?.liRef?.current.focus();
        });
    }
    render() {
        const { alignment, children, className } = this.props;
        return (React.createElement(TPAComponentsConsumer, null, ({ mobile }) => (React.createElement("ul", { onFocus: this._onFocus, onMouseDown: this._preventFocus, onKeyDown: this._onKeyDown, className: st(classes.root, { mobile }, className), ...this.getDataAttributes(mobile), "data-hook": this.props['data-hook'], role: "menu", "aria-labelledby": this.props['aria-labeledby'], "aria-label": this.props['aria-label'], tabIndex: 0 }, React.Children.map(children, (child, index) => child.type === ActionsMenuLayoutItem
            ? React.cloneElement(child, {
                className: classes.item,
                alignment,
                ref: (_ref) => {
                    this._addRef(_ref, index);
                },
            })
            : child)))));
    }
}
ActionsMenuLayout.Item = ActionsMenuLayoutItem;
ActionsMenuLayout.Divider = ActionsMenuLayoutDivider;
ActionsMenuLayout.displayName = 'ActionsMenuLayout';
//# sourceMappingURL=ActionsMenuLayout.js.map